// Discipline (Saturn): every constellation scores more, less a step for
// each star still unused, blocked or free; never below nothing (Aaron,
// 2026-11-04). Live, so the bonus grows as the sky fills.
import { ALIGNMENT_NUMBERS as N } from '../constants';
import type { AlignmentContext, AlignmentDef } from '../types';

export function disciplinePercent(unused: number): number {
  return Math.max(0, N.disciplinePercent - N.disciplineStep * unused);
}

export const discipline: AlignmentDef = {
  id: 'discipline',
  planet: 'saturn',
  name: 'Discipline',
  text: (ctx: AlignmentContext | null) =>
    `Every constellation scores +${N.disciplinePercent}%, less ${N.disciplineStep}% for each unused star. Currently +${disciplinePercent(ctx?.unused ?? N.disciplinePercent / N.disciplineStep)}%.`,
  wordPercent: (_c, ctx) => disciplinePercent(ctx.unused),
};
